import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 32"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M12.75 10.75V13h7.5v-2.25A3.75 3.75 0 0 0 16.5 7a3.75 3.75 0 0 0-3.75 3.75m-3 2.25v-2.25A6.75 6.75 0 0 1 16.5 4a6.75 6.75 0 0 1 6.75 6.75V13H24c1.655 0 3 1.345 3 3v9c0 1.655-1.345 3-3 3H9c-1.655 0-3-1.345-3-3v-9c0-1.655 1.345-3 3-3z" }, null, -1)
  ]))]))
}
export default { render: render }